// Gold coin sprite for the offline screen's win burst (KioskOfflineOverlay).
// Particle art: the shades of the coin are painted on a canvas, which cannot read CSS tokens,
// so they live here with the other art data instead of in a component.

/** Gold coin with a $ symbol, painted once into a square canvas of side SS. */
export function paintGoldCoin(oc: CanvasRenderingContext2D, SS: number) {
  const MX = SS / 2, MY = SS / 2, CR = SS * 0.46;
  oc.beginPath(); oc.arc(MX, MY, CR, 0, Math.PI * 2);
  oc.fillStyle = '#6b3d00'; oc.fill();
  oc.beginPath(); oc.arc(MX, MY, CR * 0.95, 0, Math.PI * 2);
  oc.fillStyle = '#c47d00'; oc.fill();
  const body = oc.createRadialGradient(MX - CR * 0.28, MY - CR * 0.28, CR * 0.04, MX, MY, CR * 0.88);
  body.addColorStop(0, '#fff8c0'); body.addColorStop(0.18, '#ffe033');
  body.addColorStop(0.55, '#e6a800'); body.addColorStop(0.85, '#b87000'); body.addColorStop(1, '#8a4e00');
  oc.beginPath(); oc.arc(MX, MY, CR * 0.88, 0, Math.PI * 2); oc.fillStyle = body; oc.fill();
  oc.beginPath(); oc.arc(MX, MY, CR * 0.70, 0, Math.PI * 2);
  oc.strokeStyle = 'rgba(120,65,0,0.55)'; oc.lineWidth = CR * 0.045; oc.stroke();
  oc.font = `900 ${Math.round(CR * 0.92)}px Georgia,serif`;
  oc.textAlign = 'center'; oc.textBaseline = 'middle';
  oc.fillStyle = 'rgba(80,35,0,0.7)'; oc.fillText('$', MX + 2, MY + 3);
  oc.fillStyle = '#6b3200'; oc.fillText('$', MX, MY);
  oc.strokeStyle = 'rgba(255,230,120,0.35)'; oc.lineWidth = 1.5; oc.strokeText('$', MX, MY);
  const sheen = oc.createRadialGradient(MX - CR * 0.38, MY - CR * 0.38, 0, MX - CR * 0.22, MY - CR * 0.22, CR * 0.58);
  sheen.addColorStop(0, 'rgba(255,255,240,0.72)'); sheen.addColorStop(1, 'rgba(255,255,200,0)');
  oc.beginPath(); oc.arc(MX, MY, CR * 0.88, 0, Math.PI * 2); oc.fillStyle = sheen; oc.fill();
}
